import React, { useState } from 'react';

const ContentTab = ({ updateChatTabData,chatTabData }) => {
    const [bubbleText, setBubbleText] = useState(chatTabData.bubble_text);
    const [chatWindowImage, setChatWindowImage] = useState(chatTabData.chat_window_picture);
    const [chatWindowName, setChatWindowName] = useState(chatTabData.chat_window_name);
    const [welcomeMessage, setWelcomeMessage] = useState(chatTabData.welcome_message);
    const [startChatButtonText, setStartChatButtonText] = useState(chatTabData.start_chat_button_text);
    const [showShowStartChatButton, setShowStartChatButton] = useState(Number(chatTabData.is_show_start_chat_button));

     // Handlers Bubble Text Change
    const handleBubbleTextChange = (event) => {
        const value = event.target.value;
        setBubbleText(value);
        updateChatTabData("bubble_text", value);
    };

    // Handlers Bubble Text Change
    const handleChatWindowImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setChatWindowImage(URL.createObjectURL(file));
            updateChatTabData("chat_window_picture", file);
        }
    }

    // Handlers Chat Window Name Change
    const handleChatWindowNameChange = (event) => {
        const value = event.target.value;
        setChatWindowName(value);
        updateChatTabData("chat_window_name", value);
    };

    // Handlers Welcome Message Change
    const handleWelcomeMessageChange = (event) => {
        const value = event.target.value;
        setWelcomeMessage(value);
        updateChatTabData("welcome_message", value);
    };

    // Handlers Start Chat Button Text Change
    const handleStartChatButtonTextChange = (event) => {
        const value = event.target.value;
        setStartChatButtonText(value);
        updateChatTabData("start_chat_button_text", value);
    };

    // Handlers Show Chat Start Button Change
    const handleShowStartChatButtonChange = (e) => {
        const checked = e.target.checked;
        setShowStartChatButton(checked);
        updateChatTabData("is_show_start_chat_button", checked); 
    };

    return (
        <div className="whats-app-side-baar-content-tab">
            <span>Content</span>
            <div className="name-tile-row">Chat Bubble</div>
            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <input type="text" value={bubbleText} onChange={handleBubbleTextChange} placeholder="Bubble Text..." />
                </div>
            </div>
            <div className="name-tile-row">Chat Window</div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Picture</span>
                    <em>
                        <button className="button-whtsapp picture">
                            <img src={chatWindowImage} alt="Uploaded Preview" />
                        </button>
                    </em>
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleChatWindowImageChange} 
                    />
                </div>
                <div className="box-header-row bubble-text">
                    <label>Name</label>
                    <input type="text" value={chatWindowName} onChange={handleChatWindowNameChange} placeholder="John Doe" />
                </div>
                <div className="box-header-row">
                    <span>Caption</span>
                    <em>{chatTabData.chat_window_caption}</em>
                </div>
            </div>
            <div className="name-tile-row">Welcome Message</div>
            <div className="side-baar-box-header">
                <div className="box-header-row welcome-message">
                    <textarea value={welcomeMessage} onChange={handleWelcomeMessageChange} placeholder="Type Message..." defaultValue="Hi there 👋 How can I help you?"></textarea>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <span>Start Chat Button Text</span>
                    <input type="text" value={startChatButtonText} onChange={handleStartChatButtonTextChange} />
                </div>
            </div>
            <div className="box-header-row last-border-none">
                <span>Show Icon in Start Chat Button</span>
                <div className="form-group">
                    <input id="show_icon_in_button_toggle" className="chkbx-toggle" type="checkbox" checked={showShowStartChatButton} onChange={handleShowStartChatButtonChange} />
                    <label for="show_icon_in_button_toggle"></label>
                </div>
            </div>
        </div>
    );
};

export default ContentTab;